import * as React from 'react';

type Option = {
  text: string;
  icon?: string;
};

type TabsProps = {
  onChange: (
    value: string,
    index: number,
  ) => (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  options: Option[];
  activeTabIndex: number;
  disabled?: boolean;
};

const defaultBtnClass = 'btn btn-default';
const activeBtnClass = 'btn btn-info active';

const Tab = (props: {
  index: number;
  value: string;
  icon: string;
  onChange: TabsProps['onChange'];
  isActive: boolean;
  disabled: boolean;
}) => {
  const { index, value, onChange, isActive, icon, disabled } = props;
  return (
    <button
      disabled={disabled}
      className={isActive ? activeBtnClass : defaultBtnClass}
      onClick={onChange(value, index)}
    >
      {icon && <i className={`fa fa-${icon}`}></i>} {value}
    </button>
  );
};

const Tabs = (props: TabsProps) => {
  const { onChange, options, activeTabIndex, disabled } = props;
  return (
    <div style={{ width: '100%' }}>
      <div className="tabs-container">
        {options.map(({ text, icon }, i) => (
          <Tab
            key={i}
            isActive={activeTabIndex === i}
            onChange={onChange}
            value={text}
            icon={icon}
            index={i}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
};

export default Tabs;
